// oxlint-disable-file no-danger
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'clsx';
import { Button } from '../button';

import {
  NOTIFICATION_TYPES,
  NOTIFICATION_TYPE_INFO,
  NOTIFICATION_TYPE_ERROR,
  NOTIFICATION_TYPE_WARNING,
  NOTIFICATION_TYPE_SUCCESS,
} from '../../services/notification-service';
import { ButtonThemeService } from '../../services/button-theme-service';

import style from './notification.module.less';
import { noop } from 'ui-components/default-props/noop';
import { emptyArray } from 'ui-components/default-props/empty';

const notificationTypeToIcon = {
  [NOTIFICATION_TYPE_ERROR]: <FontAwesomeIcon icon={faExclamationCircle} />,
  [NOTIFICATION_TYPE_WARNING]: <FontAwesomeIcon icon={faExclamationTriangle} />,
  [NOTIFICATION_TYPE_SUCCESS]: <FontAwesomeIcon icon={faCheckCircle} />,
  [NOTIFICATION_TYPE_INFO]: <FontAwesomeIcon icon={faInfoCircle} />,
};

const renderButton = (buttonConfig, index) => {
  const { text, theme, callback } = buttonConfig;
  return (
    <Button key={index} onClick={callback} theme={theme}>
      {text}
    </Button>
  );
};

export const NotificationContent = ({
  buttons = emptyArray,
  content,
  notificationType = NOTIFICATION_TYPE_INFO,
  onClick = noop,
  title,
}) => (
  <div className={style['notification-content']} onClick={onClick}>
    <div className={classnames(style['notification-icon-wrapper'], style[`theme-${notificationType}`])}>
      {notificationTypeToIcon[notificationType] ?? <FontAwesomeIcon icon={faExclamationCircle} />}
    </div>
    <div>
      {!title ? null : <div className={classnames(style['notification-title'], style[`theme-${notificationType}`])}>{title}</div>}
      <div className={style['notification-body']}>{content}</div>
      <div className={style.buttons}>{buttons.map((buttonConfig, index) => renderButton(buttonConfig, index))}</div>
    </div>
  </div>
);

NotificationContent.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  notificationType: PropTypes.oneOf(NOTIFICATION_TYPES),
  onClick: PropTypes.func,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.node,
      theme: PropTypes.oneOf(ButtonThemeService.getButtonThemes()),
      callback: PropTypes.func,
    }),
  ),
};
